import React, {useContext, useEffect, useState} from 'react';
import {useParams, useLocation, useHistory, useRouteMatch} from 'react-router-dom';
import UserContext from '../../context/UserContext';
import CampaignContext from '../../context/CampaignContext';
import Picture from '../../components/Picture';
import {getCharacter, claimCharacter} from '../characterRepository';
import {vtmT} from '../i18n';
import '../../styles/vtm/sheet.css';
import '../../styles/vtm/roll.css';
import '../../styles/vtm/dm.css';

/**
 * Page ouverte par le joueur depuis le lien d'attribution du MJ (…/claim/:characterUid?t=jeton).
 * Le joueur connecté devient propriétaire du personnage repris.
 */
const VtmClaimPage = () => {
  const {characterUid} = useParams();
  const token = new URLSearchParams(useLocation().search).get('t');
  const history = useHistory();
  const match = useRouteMatch();
  const {user} = useContext(UserContext);
  const {campaign} = useContext(CampaignContext);
  // loading | ready | invalid | error
  const [state, setState] = useState('loading');
  const [character, setCharacter] = useState(null);
  const [busy, setBusy] = useState(false);
  // La route est /campaigns/:campaignId/claim/:characterUid : la fiche est à /campaigns/:campaignId/:characterUid
  const sheetUrl = match.url.replace(/\/claim\/[^/]+\/?$/, `/${characterUid}`);

  useEffect(() => {
    getCharacter(characterUid)
      .then(data => {
        setCharacter(data);
        setState(data && data.active && token && data.claimToken === token ? 'ready' : 'invalid');
      })
      .catch(e => {
        console.log(e);
        setState('invalid');
      });
  }, [characterUid, token]);

  const claim = async () => {
    setBusy(true);
    try {
      await claimCharacter(characterUid, user.uid);
      history.push(sheetUrl);
    } catch (e) {
      console.log(e);
      setState('error');
      setBusy(false);
    }
  };

  // Le MJ qui ouvre son propre lien pour le vérifier ne doit pas s'attribuer le personnage.
  const isDm = Boolean(campaign.uid) && campaign.idUserDm === user.uid;

  return (
    <div className="vtmClaim">
      <h1 className="vtmModalTitle">{vtmT('claimTitle')}</h1>
      {state === 'loading' && <p>{vtmT('loading')}</p>}
      {state === 'invalid' && <p>{vtmT('claimInvalid')}</p>}
      {state === 'error' && <p>{vtmT('claimError')}</p>}
      {state === 'ready' && (
        <>
          <div className="vtmClaimPortrait"><Picture character={character} /></div>
          <p>{vtmT('claimIntro', {name: character.name})}</p>
          {isDm
            ? <p>{vtmT('claimIsDm')}</p>
            : <button type="button" className="vtmButton primary" onClick={claim} disabled={busy}>{vtmT('claimAction')}</button>}
        </>
      )}
    </div>
  );
};

export default VtmClaimPage;
